function Luminous() {
  return (
    <svg
      width={167}
      height={34}
      viewBox="0 0 167 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0835 13.5873C15.4042 11.5209 18.7856 8.01423 20.7268 3.63093C19.4744 2.31594 17.8463 1.37666 16.093 0.813093L15.1537 0.5C15.0911 0.625237 15.0285 0.813101 15.0285 0.938338C13.5256 5.1964 10.4573 8.64042 6.32448 10.5816C3.44403 11.9592 1.31499 14.4639 0.313093 17.4696L0 18.4089C0.125237 18.4715 0.313096 18.5341 0.438333 18.5341C1.62809 18.9725 2.81784 19.536 3.94497 20.2249C5.51044 17.407 8.01518 15.0275 11.0835 13.5873Z"
        fill="#2583FF"
      />
      <path
        d="M29.2428 13.8378C26.926 17.3444 23.7324 20.1622 19.7874 22.0408C16.5939 23.5437 14.1518 26.3615 13.0246 29.7429L12.7115 30.8074C13.9013 31.8719 15.3415 32.686 16.907 33.1869L17.8463 33.5C17.9089 33.3748 17.9715 33.1869 17.9715 33.0617C19.4744 28.8036 22.5427 25.3596 26.6755 23.4184C29.5559 22.0408 31.7476 19.5361 32.6869 16.5304L33 15.5911C31.685 15.2154 30.4326 14.5892 29.2428 13.8378Z"
        fill="#2583FF"
      />
      <path
        d="M10.2068 27.5511C11.7723 23.794 14.6528 20.7257 18.3473 18.9724C21.7287 17.3443 24.5465 14.8395 26.4877 11.7712C25.0474 10.3936 23.8577 8.82814 22.981 6.94958C20.6641 11.2076 17.0323 14.6517 12.5863 16.7807C10.019 17.9705 7.95257 20.0369 6.7002 22.5416C8.0778 23.8566 9.20494 25.4847 10.0816 27.3006C10.0816 27.3006 10.1442 27.4259 10.2068 27.5511Z"
        fill="#2583FF"
      />
      <path
        d="M45.95 27.0001H60.02V23.1001H50.48V6.00006H45.95V27.0001Z"
        fill="white"
      />
      <path
        d="M74.7198 11.8801H70.5198V20.1601C70.5198 22.0801 69.2298 23.5201 67.3998 23.5201C65.6898 23.5201 64.4898 22.2001 64.4898 20.3701V11.8801H60.3198V21.3001C60.3198 24.7501 62.5398 27.2401 65.9298 27.2401C67.9998 27.2401 69.6798 26.3401 70.5198 24.9001V27.0001H74.7198V11.8801Z"
        fill="white"
      />
      <path
        d="M76.28 27.0001H80.48V18.4201C80.48 16.4701 81.59 15.1801 83.33 15.1801C84.95 15.1801 85.97 16.4701 85.97 18.4201V27.0001H90.17V18.4201C90.17 16.4701 91.28 15.1801 93.02 15.1801C94.64 15.1801 95.69 16.4701 95.69 18.4201V27.0001H99.86V17.1001C99.86 14.0701 97.73 11.6401 94.43 11.6401C92 11.6401 90.11 12.9301 89.39 14.4001C88.67 12.6001 87.14 11.6401 84.77 11.6401C82.73 11.6401 81.29 12.6301 80.48 14.0101V11.8801H76.28V27.0001Z"
        fill="white"
      />
      <path
        d="M101.291 5.31006V9.72006H105.731V5.31006H101.291ZM101.411 27.0001H105.611V11.8801H101.411V27.0001Z"
        fill="white"
      />
      <path
        d="M107.176 27.0001H111.376V18.7201C111.376 16.7701 112.666 15.3601 114.496 15.3601C116.236 15.3601 117.406 16.6801 117.406 18.5101V27.0001H121.606V17.5801C121.606 14.1001 119.386 11.6401 115.966 11.6401C113.896 11.6401 112.216 12.5101 111.376 13.9801V11.8801H107.176V27.0001Z"
        fill="white"
      />
      <path
        d="M130.367 27.2401C135.017 27.2401 138.347 23.9401 138.347 19.4401C138.347 14.9401 135.017 11.6401 130.367 11.6401C125.717 11.6401 122.387 14.9401 122.387 19.4401C122.387 23.9401 125.717 27.2401 130.367 27.2401ZM130.367 23.6401C128.117 23.6401 126.587 21.9301 126.587 19.4401C126.587 16.9201 128.117 15.2101 130.367 15.2101C132.617 15.2101 134.147 16.9201 134.147 19.4401C134.147 21.9301 132.617 23.6401 130.367 23.6401Z"
        fill="white"
      />
      <path
        d="M153.558 11.8801H149.358V20.1601C149.358 22.0801 148.068 23.5201 146.238 23.5201C144.528 23.5201 143.328 22.2001 143.328 20.3701V11.8801H139.158V21.3001C139.158 24.7501 141.378 27.2401 144.768 27.2401C146.838 27.2401 148.518 26.3401 149.358 24.9001V27.0001H153.558V11.8801Z"
        fill="white"
      />
      <path
        d="M160.638 27.2401C164.178 27.2401 166.518 25.3501 166.518 22.4701C166.518 15.6301 158.238 19.1401 158.238 16.0501C158.238 15.0901 159.048 14.5801 160.218 14.5801C161.358 14.5801 162.528 15.2701 162.708 16.5601H166.338C166.188 13.5901 163.728 11.6401 160.098 11.6401C157.008 11.6401 154.698 13.5301 154.698 16.2001C154.698 22.5601 162.828 19.5301 162.828 22.6201C162.828 23.4601 161.928 24.0901 160.638 24.0901C159.078 24.0901 158.028 23.2501 157.878 21.9001H154.278C154.428 25.1701 156.948 27.2401 160.638 27.2401Z"
        fill="white"
      />
    </svg>

  );
}

export default Luminous;